import React from 'react';

import { Brand, Search } from '@zoomit/icons';
import { Flex, Skeleton } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

const KeyWordSectionSkeleton = () => {
  return (
    <Flex flexDirection="column" gap={1.2}>
      <Flex gap={0.8} alignItems="center">
        <Brand fill={cssVar(theme.grey1)} />
        <Skeleton variant="text" width={16} />
      </Flex>
      <Flex gap={0.8} alignItems="center">
        <Search fill={cssVar(theme.grey1)} />
        <Skeleton variant="text" width={16} />
      </Flex>
    </Flex>
  );
};

export default KeyWordSectionSkeleton;
